import settings from '@/settings'

const getPostos = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/postos/all/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const redeSocial = (headers, payload) => {
  const data = {
    method: payload.method || 'GET',
    mode: 'cors',
    headers: headers
  }
  if (payload.method === 'GET') data.cache = 'default'
  else data.body = JSON.stringify(payload)
  return fetch(`${settings.apetrusApi}/postos/redesocial/${payload.cnpj}/`, data)
}

const verificaPostologado = (headers) => {
  return fetch(`${settings.apetrusApi}/clientes/postoporpessoa/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const meusPostos = (headers) => {
  return fetch(`${settings.apetrusApi}/postos/meuspostos/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const detalhar = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/?cnpj=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const listBandeiras = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/bandeiras/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const inserirBandeira = (bandeira, headers) => {
  return fetch(`${settings.apetrusApi}/bandeiras/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(bandeira),
    mode: 'cors',
    headers: headers
  })
}

const insertMaquineta = (cnpj, merchantid, merchantkey, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizarmaquineta/`, {
    method: 'PUT',
    body: JSON.stringify({
      cnpj: cnpj,
      merchantid: merchantid,
      merchantkey: merchantkey
    }),
    mode: 'cors',
    headers: headers
  })
}

const listAllCombustiveis = (headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const relatorioCompras = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/compras/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const relatorioComprasPosto = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/comprasnoposto/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const relatorioComprasConveio = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/comconvenio/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const relatorioVouchers = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/vouchers/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const listCombustiveis = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/combustiveis/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const emailCliente = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

const inserir = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/inserir/`, {
    method: 'POST',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const inserirByAdm = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/inserir_pelo_adm/`, {
    method: 'POST',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const inserirByClient = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/inserir_pelo_cliente/`, {
    method: 'POST',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const atualizarEnderecoPosto = (cnpj, posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizar_endereco_posto/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const geolocatePosto = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizarlocalizacao/`, {
    method: 'PUT',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const precificarPosto = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/precificar/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const aceitarTermos = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/aceitartermos/?cnpj=${cnpj}`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const contact = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/sendmail/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

const getFaqs = () => {
  return fetch(`${settings.apetrusApi}/faq/posto/`, {
    method: 'GET',
    mode: 'cors'
  })
}

const getEndereco = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/buscar_endereco_posto/?cnpj=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const atualizarLogoPosto = (cnpj, imagem, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizarlogoposto/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(imagem),
    mode: 'cors',
    headers: headers
  })
}

const atualizarImagemPosto = (cnpj, imagem, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizarimagemposto/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(imagem),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarHorarioFuncionamento = (cnpj, horario, headers) => {
  return fetch(`${settings.apetrusApi}/postos/cadastrarHorario/?cnpj=${cnpj}`, {
    method: 'POST',
    body: JSON.stringify(horario),
    mode: 'cors',
    headers: headers
  })
}

const confirmarServicos = (cnpj, posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/confirmarservicos/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const getHorarioFuncionamento = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/horariofuncionamento/?cnpj=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}
const salvarDadosConsolidacao = (compra, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/salvar_cons_pagamento/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(compra),
    mode: 'cors',
    headers: headers
  })
}

const salvarDadosConsolidacaoAbastecimento = (compra, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/salvar_cons_abastecimento/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify(compra),
    mode: 'cors',
    headers: headers
  })
}

const consolidarPagamento = (dia, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/consolidar_pagamento/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify({
      dia: dia
    }),
    mode: 'cors',
    headers: headers
  })
}

const consolidarAbastecimento = (dia, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/consolidar_abastecimento/?cnpj=${cnpj}`, {
    method: 'PUT',
    body: JSON.stringify({
      dia: dia
    }),
    mode: 'cors',
    headers: headers
  })
}

const getConsolidacoes = (intervalo, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/consolidacoes/?cnpj=${cnpj}&start=${encodeURIComponent(intervalo.start)}&end=${encodeURIComponent(intervalo.end)}`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

const cadastrarpin = (cnpjPosto, pin, headers) => {
  return fetch(`${settings.apetrusApi}/postos/criar_ou_atualizar_pin/`, {
    method: 'PUT',
    body: JSON.stringify({
      pin: pin,
      cnpj: cnpjPosto
    }),
    mode: 'cors',
    headers: headers
  })
}

const autenticarPin = (cnpjPosto, pin, headers) => {
  return fetch(`${settings.apetrusApi}/postos/autenticarpin/`, {
    method: 'POST',
    body: JSON.stringify({
      'cnpj': cnpjPosto,
      'pin': pin
    }),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarEmailPosto = (data, headers) => {
  return fetch(`${settings.apetrusApi}/postos/informacoesemailposto/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const meusClientes = (headers, filtros) => {
  let url = `${settings.apetrusApi}/postos/meusclientes/`

  if (filtros) {
    const keys = Object.keys(filtros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${filtros[keys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const enviarEmailParaClientes = (data, headers) => {
  return fetch(`${settings.apetrusApi}/postos/enviaremailparaclientes/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const pushNotification = (data, posto, headers) => {
  return fetch(`${settings.apetrusApi}/notificacoes/push/?posto=${posto}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const fidelidadePosto = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/fidelidadeposto/${cnpj}/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const deletarPremio = (data, posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/premiofidelidade/?posto=${posto}`, {
    method: 'DELETE',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarPremio = (data, posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/premiofidelidade/?posto=${posto}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const pegarPremios = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/premiofidelidade/?posto=${posto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const permitirReceberPosPago = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/receberpospago/?posto=${posto}`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const getTiposPagamntosPosPago = (cnpjPosto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/tiposPagamentoPospago/?posto=${cnpjPosto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const update24horas = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/atualizar_posto_24_horas/?posto=${posto}`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const aderirCashPosto = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/aderircashposto/?posto=${posto}`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const inserirImagemPremio = (data, posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/premiofidelidade/?posto=${posto}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const relatorioPremios = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/relatoriopremios/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const relatorioCash = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/relatoriocash/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const transferirPosto = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/transferirposto/?posto=${data.cnpj}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const solicitacoesDeTransferencia = (headers) => {
  return fetch(`${settings.apetrusApi}/postos/pegarSolicitacoes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const responderSolicitacao = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/repondertransferencia/${data.id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const relatorioVouchersEmpresa = (filtros, cnpj, headers, pagination) => {
  const keys = Object.keys(filtros)
  let url = `${settings.apetrusApi}/postos/relatoriovoucherempresas/?page=${pagination.page}&posto=${cnpj}`
  for (let i = 0; i < keys.length; i++) {
    url = `${url}&${keys[i]}=${filtros[keys[i]]}`
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const programaIncentivo = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/programaincentivo/${data.cnpj}/`, {
    method: 'PUT',
    body: JSON.stringify({ programa_incentivo: data.programa_incentivo }),
    mode: 'cors',
    headers: headers
  })
}

const mostrarPrecos = (headers, cnpj, data) => {
  return fetch(`${settings.apetrusApi}/postos/mostrarpreco/${cnpj}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const programaDeFidelidade = (headers, cnpj, data) => {
  return fetch(`${settings.apetrusApi}/postos/programadefidelidade/${cnpj}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarMeioRecebimento = (headers, cnpj, data) => {
  return fetch(`${settings.apetrusApi}/postos/meiorecebimento/${cnpj}/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const deletarMeioRecebimento = (headers, cnpj, data) => {
  return fetch(`${settings.apetrusApi}/postos/meiorecebimento/${cnpj}/`, {
    method: 'DELETE',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const pegarMeioRecebimento = (headers, cnpj) => {
  return fetch(`${settings.apetrusApi}/postos/meiorecebimento/${cnpj}/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

const relatorioPix = (data, cnpj, headers) => {
  return fetch(`${settings.apiPayment}/efi/listacobrancas/?posto=${cnpj}&page=${data.pagination.page - 1}${data.filtro.data_inicio ? `&data_inicio=${data.filtro.data_inicio}&data_fim=${data.filtro.data_fim}` : ``}&status=${data.filtro.status}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const smartLock = (headers, cnpj) => {
  // Ativa e desativa smartlock
  return fetch(`${settings.apetrusApi}/postos/smartlock/${cnpj}/`, {
    method: 'PATCH',
    mode: 'cors',
    headers: headers
  })
}

const criarCarteiraVirtual = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/carteiravirtual/criar/${cnpj}/?is_posto=${true}`, {
    method: 'POST',
    body: JSON.stringify(cnpj),
    mode: 'cors',
    headers: headers
  })
}

const pegarCarteiraVirtual = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/carteiravirtual/${cnpj}/?is_posto=${true}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const pegarHistoricoDaCarteiraVirtual = (headers, filtros) => {
  let url = `${settings.apetrusApi}/carteiravirtual/historico/${filtros.id_carteira}/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const solicitarRetiradaDeSaldo = (cnpj, headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/solicitacaoretirada/${cnpj}/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const getPostosAtivos = (headers, payload) => {
  let url = `${settings.apetrusApi}/postos/postosativos/?notPaged=${true}`
  Object.keys(payload.filtros).forEach((filter) => {
    url = `${url}&${filter}=${payload.filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const transferirSaldo = (payload, headers) => {
  return fetch(`${settings.apetrusApi}/postos/transferircredito/${payload.cnpj_pagador}/`, {
    method: 'POST',
    body: JSON.stringify({ is_posto: payload.is_posto, cpf_receptor: payload.cpf_receptor, valor_pago: payload.valor_pago, cnpj_receptor: payload.cnpj_receptor }),
    mode: 'cors',
    headers: headers
  })
}

const recebimentoClientes = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/recebimentocarteiraclientes/${cnpj}/`, {
    method: 'PATCH',
    mode: 'cors',
    headers: headers
  })
}

const recebimentoEmpresas = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/recebimentocarteiraempresas/${cnpj}/`, {
    method: 'PATCH',
    mode: 'cors',
    headers: headers
  })
}

const alterarTipoDesconto = (cnpj, headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/alterartipodedesconto/${cnpj}/`, {
    method: 'PATCH',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const atualizar = (headers, cnpj, data) => {
  return fetch(`${settings.apetrusApi}/postos/${cnpj}/atualizar/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let exportarCompras = (headers, data) => {
  let url = `${settings.apetrusApi}/postos/compras/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  redeSocial,
  criarCarteiraVirtual,
  pegarCarteiraVirtual,
  pegarHistoricoDaCarteiraVirtual,
  listAllCombustiveis,
  listCombustiveis,
  listBandeiras,
  inserirBandeira,
  getPostos,
  detalhar,
  meusPostos,
  emailCliente,
  inserir,
  inserirByAdm,
  inserirByClient,
  atualizarEnderecoPosto,
  insertMaquineta,
  relatorioCompras,
  relatorioComprasPosto,
  relatorioVouchers,
  verificaPostologado,
  geolocatePosto,
  precificarPosto,
  aceitarTermos,
  contact,
  getFaqs,
  getEndereco,
  atualizarLogoPosto,
  atualizarImagemPosto,
  cadastrarHorarioFuncionamento,
  confirmarServicos,
  getHorarioFuncionamento,
  salvarDadosConsolidacao,
  salvarDadosConsolidacaoAbastecimento,
  consolidarPagamento,
  consolidarAbastecimento,
  getConsolidacoes,
  cadastrarpin,
  autenticarPin,
  cadastrarEmailPosto,
  meusClientes,
  enviarEmailParaClientes,
  pushNotification,
  deletarPremio,
  cadastrarPremio,
  pegarPremios,
  permitirReceberPosPago,
  getTiposPagamntosPosPago,
  aderirCashPosto,
  update24horas,
  inserirImagemPremio,
  relatorioPremios,
  relatorioCash,
  transferirPosto,
  solicitacoesDeTransferencia,
  responderSolicitacao,
  relatorioVouchersEmpresa,
  programaIncentivo,
  fidelidadePosto,
  mostrarPrecos,
  programaDeFidelidade,
  cadastrarMeioRecebimento,
  deletarMeioRecebimento,
  pegarMeioRecebimento,
  relatorioPix,
  smartLock,
  relatorioComprasConveio,
  solicitarRetiradaDeSaldo,
  getPostosAtivos,
  transferirSaldo,
  recebimentoClientes,
  recebimentoEmpresas,
  alterarTipoDesconto,
  atualizar,
  exportarCompras
}
